<div fxLayout="column" fxLayoutAlign="start stretch"  [class.error]="error !== '' && error !== null" >
    <mat-form-field [appearance]="this.appearance">
        <mat-label>{{label}}</mat-label>
        <input type="text"
            (click)="inputClick()"
            placeholder="{{placeholder}}"
            matInput
            [(ngModel)]="value"
            [matAutocomplete]="auto"
            (keydown)="keydown($event)"
            (keyup)="keyup($event)"
            [required]=required
            [disabled]=disabled
            (change)="inputChange()"
            matAutocompletePosition="below"
        >
        <mat-progress-spinner *ngIf="showSpinner" matSuffix mode="indeterminate" diameter="25" class="color"></mat-progress-spinner>
        <mat-autocomplete #auto="matAutocomplete" 
            [panelWidth]="panelWidth"
            (optionSelected)="onOptionActivated($event)"
            (optionActivated)="onOptionActivated($event)" 
            [displayWith]="displayWithFn" 
            [autoActiveFirstOption]="true"
            (closed)="onPanelClosed()"
            (opened)="onPanelOpened()"
        >
            <mat-option *ngIf="labelForAll" value="">{{labelForAll}}</mat-option>
            <mat-option *ngFor="let row of getFilteredData()" [value]="row[valueColumn]"><mat-icon *ngIf="hasIcon">{{getIcon(row)}}</mat-icon>{{rowFormatterFn!(row)}}</mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="error">{{error}}</mat-error>
    </mat-form-field>
    <div error *ngIf="error">{{error}}</div>
</div>